import { useTranslation } from 'react-i18next';

const fallbackStrip = [
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23e8ddd0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='12' fill='%237a6a5a'%3ES1%3C/text%3E%3C/svg%3E",
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23ddd5c7'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='12' fill='%237a6a5a'%3ES2%3C/text%3E%3C/svg%3E",
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23d9cfc0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='12' fill='%237a6a5a'%3ES3%3C/text%3E%3C/svg%3E",
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23e0d8cc'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='12' fill='%237a6a5a'%3ES4%3C/text%3E%3C/svg%3E",
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23d4ccc0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='12' fill='%237a6a5a'%3ES5%3C/text%3E%3C/svg%3E",
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23e2d9cc'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='12' fill='%237a6a5a'%3ES6%3C/text%3E%3C/svg%3E",
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23eae3d8'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='12' fill='%237a6a5a'%3ES7%3C/text%3E%3C/svg%3E",
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect width='100' height='100' fill='%23ddd4c5'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='12' fill='%237a6a5a'%3ES8%3C/text%3E%3C/svg%3E",
];

export default function CTABanner() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Centered text + CTA */}
        <div className="text-center max-w-xl mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-foreground-950 leading-tight">
            {t('cta.title')}
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
            {t('cta.subtitle')}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>{t('cta.button')}</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* Bottom product image strip */}
        <div className="mt-16 flex gap-3 md:gap-4 overflow-hidden justify-center">
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Minimal%20white%20sneakers%20on%20cream%20background%20clean%20product%20photography%20soft%20light%20no%20text%20no%20logos%20European%20aesthetic%20editorial%20style%20high%20detail&width=100&height=100&seq=cta-strip-1-v2&orientation=squarish"
              alt="Kakobuy Spreadsheet product 1"
              title="Kakobuy Spreadsheet – Produkt"
              className="w-full h-full object-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = fallbackStrip[0]; }}
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Beige%20cotton%20t-shirt%20on%20cream%20background%20clean%20product%20photography%20soft%20light%20no%20text%20no%20logos%20European%20aesthetic%20editorial%20style%20high%20detail&width=100&height=100&seq=cta-strip-2-v2&orientation=squarish"
              alt="Kakobuy Spreadsheet product 2"
              title="Kakobuy Spreadsheet – Produkt"
              className="w-full h-full object-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = fallbackStrip[1]; }}
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Tan%20leather%20bag%20on%20cream%20background%20clean%20product%20photography%20soft%20light%20no%20text%20no%20logos%20European%20aesthetic%20editorial%20style%20high%20detail&width=100&height=100&seq=cta-strip-3-v2&orientation=squarish"
              alt="Kakobuy Spreadsheet product 3"
              title="Kakobuy Spreadsheet – Produkt"
              className="w-full h-full object-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = fallbackStrip[2]; }}
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Stylish%20sunglasses%20on%20cream%20background%20clean%20product%20photography%20soft%20light%20no%20text%20no%20logos%20European%20aesthetic%20editorial%20style%20high%20detail&width=100&height=100&seq=cta-strip-4-v2&orientation=squarish"
              alt="Kakobuy Spreadsheet product 4"
              title="Kakobuy Spreadsheet – Produkt"
              className="w-full h-full object-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = fallbackStrip[3]; }}
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20watch%20on%20cream%20background%20clean%20product%20photography%20soft%20light%20no%20text%20no%20logos%20European%20aesthetic%20editorial%20style%20high%20detail&width=100&height=100&seq=cta-strip-5-v2&orientation=squarish"
              alt="Kakobuy Spreadsheet product 5"
              title="Kakobuy Spreadsheet – Produkt"
              className="w-full h-full object-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = fallbackStrip[4]; }}
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Minimal%20belt%20on%20cream%20background%20clean%20product%20photography%20soft%20light%20no%20text%20no%20logos%20European%20aesthetic%20editorial%20style%20high%20detail&width=100&height=100&seq=cta-strip-6-v2&orientation=squarish"
              alt="Kakobuy Spreadsheet product 6"
              title="Kakobuy Spreadsheet – Produkt"
              className="w-full h-full object-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = fallbackStrip[5]; }}
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Designer%20perfume%20bottle%20on%20cream%20background%20clean%20product%20photography%20soft%20light%20no%20text%20no%20logos%20European%20aesthetic%20editorial%20style%20high%20detail&width=100&height=100&seq=cta-strip-7-v2&orientation=squarish"
              alt="Kakobuy Spreadsheet product 7"
              title="Kakobuy Spreadsheet – Produkt"
              className="w-full h-full object-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = fallbackStrip[6]; }}
            />
          </div>
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Knitted%20beanie%20hat%20on%20cream%20background%20clean%20product%20photography%20soft%20light%20no%20text%20no%20logos%20European%20aesthetic%20editorial%20style%20high%20detail&width=100&height=100&seq=cta-strip-8-v2&orientation=squarish"
              alt="Kakobuy Spreadsheet product 8"
              title="Kakobuy Spreadsheet – Produkt"
              className="w-full h-full object-cover"
              onError={(e) => { (e.target as HTMLImageElement).src = fallbackStrip[7]; }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}